import { css } from 'lit';
import { fsDesignToken } from '../core/style-util.js';

export const style = css`
  .iconic-container {
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px;
    max-width: ${fsDesignToken('fsBreakpointMedium')};
    padding: 0 ${fsDesignToken('fsSizeSpacingMedium2')};
  }

  @media (min-width: 768px) {
    .iconic-container {
      max-width: ${fsDesignToken('fsBreakpointMedium')};
      padding: 0;
    }
  }

  @media (min-width: ${fsDesignToken('fsBreakpointExtraLarge')}) {
    .iconic-container {
      max-width: 768px;
    }
  }
`;
